export var getBrokerEntityPlatformMap = function getBrokerEntityPlatformMap() {
  return {
    acturis: {
      value: 'acturis',
      label: 'Acturis'
    }
  };
};
export var getBrokerEntityPlatformList = function getBrokerEntityPlatformList() {
  return Object.values(getBrokerEntityPlatformMap());
};